var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('chip',{attrs:{"name":_vm.pet.name}})}
var staticRenderFns = []

export { render, staticRenderFns }